import { IAiModel, canonicalActionTagFor } from 'state/aiModels'
import { DEFAULT_VIDEO_MODEL } from 'state/defaultAiModels'

export const DEFAULT_ASPECT_RATIO_BY_COMMAND_TAG: Record<string, string> = {
    flux: '1:1',
    flux11: '1:1',
    fluxfast: '1:1',
    dalle: '1:1',
    sd3: '1:1',
    sdl: '1:1',
    flash: '1:1',
    nb: '1:1',
    nbpro: '1:1',
    gpt4o: '1:1',
    gptimage2: '1:1',
    'gptimage2.5': '1:1',
    'gptimage2.5sunburst': '1:1',
    grokimage: '1:1',
    qwen: '1:1',
    minimax: '16:9',
    h3: '16:9',
    wan: '16:9',
    kling: '16:9',
    kling2: '16:9',
    kling3: '16:9',
    kling4: '16:9',
    seedance: '16:9',
    seedance1: '16:9',
    seedance2: '16:9',
    [DEFAULT_VIDEO_MODEL.actionTag]: '16:9',
    luma: '16:9',
    veo2: '16:9',
    veo3: '16:9',
    sora2: '16:9',
    grokvideo: '16:9',
    'grokvideo1.5': '16:9',
}

export function getDefaultAspectRatioForActionCommand(commandTag: string | null | undefined) {
    return DEFAULT_ASPECT_RATIO_BY_COMMAND_TAG[canonicalActionTagFor(commandTag)] || null
}

export function getAiModelDefaultMetadataParts(model: IAiModel): string[] {
    const parts: string[] = []
    const defaultAspectRatio = getDefaultAspectRatioForActionCommand(model.actionTagName)

    if (model.defaultDurationSeconds) {
        parts.push(`${model.defaultDurationSeconds}s`)
    }

    if (defaultAspectRatio) {
        parts.push(`AR ${defaultAspectRatio}`)
    }

    return parts
}
